/// <reference types="node" />
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { scriptLocation } from "./scriptlocation";
/**
 * configuration object available to widgets.
 */
var WidgetConfiguration = /** @class */ (function () {
    function WidgetConfiguration(widgetTag, globalConfig, configOptions) {
        var _this = this;
        this.widgetTag = widgetTag;
        this.globalConfig = globalConfig;
        this.configOptions = configOptions;
        this.environment =
            (globalConfig.widgets &&
                globalConfig.widgets[widgetTag] &&
                globalConfig.widgets[widgetTag].environment) ||
                globalConfig.environment;
        this.sharedCssUrls = globalConfig.sharedCssUrls || [];
        ["log", "debug", "info", "warn", "error"].forEach(function (x) { return (_this[x] = _this[x].bind(_this)); });
    }
    Object.defineProperty(WidgetConfiguration.prototype, "fetch", {
        /**
         * `fetch` function that widgets should use to allow the application
         * to intercept/log network calls.
         */
        get: function () {
            return this.globalConfig.fetch;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WidgetConfiguration.prototype, "bus", {
        /**
         * An instance of Bus that can be used to communicate with other widgets.
         */
        get: function () {
            return this.globalConfig.bus;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WidgetConfiguration.prototype, "useShadowDOM", {
        /**
         * Should this widget use ShadowDOM if available.
         * This is based on the browser support and the configuration options `neverUseShadowDOM`.
         */
        get: function () {
            var configNeverUseShadowDOM = this.configOptions.neverUseShadowDOM
                ? this.configOptions.neverUseShadowDOM
                : false;
            return this.globalConfig.shadowDomSupported && !configNeverUseShadowDOM;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * basic log function that widgets should use instead of `console.log`
     */
    WidgetConfiguration.prototype.log = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        this.internalLog.apply(this, ["info", message].concat(optionalParams));
    };
    /**
     * log a message at the debug level.
     */
    WidgetConfiguration.prototype.debug = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        this.internalLog.apply(this, ["debug", message].concat(optionalParams));
    };
    /**
     * log a message at the info level.
     */
    WidgetConfiguration.prototype.info = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        this.internalLog.apply(this, ["info", message].concat(optionalParams));
    };
    /**
     * log a message at the warn level.
     */
    WidgetConfiguration.prototype.warn = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        this.internalLog.apply(this, ["warn", message].concat(optionalParams));
    };
    /**
     * log a message at the error level.
     */
    WidgetConfiguration.prototype.error = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        this.internalLog.apply(this, ["error", message].concat(optionalParams));
    };
    WidgetConfiguration.prototype.myConfiguration = function () {
        var _this = this;
        this.myConfigurationPromise =
            this.myConfigurationPromise ||
                new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                    var location_1, configLocation, response, configurationData, e_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (this.globalConfig.widgets &&
                                    this.globalConfig.widgets[this.widgetTag] &&
                                    this.globalConfig.widgets[this.widgetTag].configuration) {
                                    resolve(this.globalConfig.widgets[this.widgetTag].configuration);
                                    return [2 /*return*/];
                                }
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 6, , 7]);
                                location_1 = scriptLocation(this.widgetTag);
                                configLocation = "" + location_1.path + this.widgetTag + "." + this.environment + ".json";
                                return [4 /*yield*/, this.fetch(configLocation, {
                                        credentials: this.configOptions
                                            .includeCredentialsWhenFetchingConfiguration
                                            ? "include"
                                            : "omit",
                                        headers: new Headers({ Accept: "application/json" }),
                                        method: "GET",
                                    })];
                            case 2:
                                response = _a.sent();
                                if (!!response.ok) return [3 /*break*/, 3];
                                resolve(undefined);
                                return [3 /*break*/, 5];
                            case 3: return [4 /*yield*/, response.json()];
                            case 4:
                                configurationData = _a.sent();
                                resolve(configurationData);
                                _a.label = 5;
                            case 5: return [3 /*break*/, 7];
                            case 6:
                                e_1 = _a.sent();
                                this.error("Could not load configuration", e_1);
                                resolve(undefined);
                                return [3 /*break*/, 7];
                            case 7: return [2 /*return*/];
                        }
                    });
                }); });
        return this.myConfigurationPromise;
    };
    /**
     * Internal functions used for logging.
     *
     * If no custom logging function has been given, it will use the
     * various console.xxx methods.
     */
    WidgetConfiguration.prototype.internalLog = function (level, message) {
        var _a;
        var optionalParams = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            optionalParams[_i - 2] = arguments[_i];
        }
        if (this.globalConfig.log) {
            (_a = this.globalConfig).log.apply(_a, [this.widgetTag, level, message].concat(optionalParams));
        }
        else {
            console.log.apply(console, [this.widgetTag, level, message].concat(optionalParams));
        }
    };
    return WidgetConfiguration;
}());
export { WidgetConfiguration };
export function performSanityChecks(config, options) {
    if (options === void 0) { options = {}; }
    if (window.jQuery === undefined &&
        !options.disablejQuerySanityCheck) {
        warnOrError(config, "[SANITYCHECK] jQuery is not available." +
            " Widget might depend on it so you are on your own if you do not load it.");
    }
    if (typeof window.CustomElementRegistry === "undefined") {
        warnOrError(config, "[SANITYCHECK] It seems CustomElementRegistry is not defined at all." +
            " Are you sure the necessary polyfills are loaded ?");
    }
    if (window.fetch === undefined && !options.disableFetchSanityCheck) {
        warnOrError(config, "[SANITYCHECK] It seems fetch is not available." +
            " Are you sure the necessary polyfills are loaded ?");
    }
}
export function warnOrError(config, message) {
    if (process.env.NODE_ENV === "production") {
        var logFunction = config !== undefined ? config.warn : console.warn;
        logFunction("[@sg-widgets/shared-core] WARNING: " + message);
    }
    else {
        throw new Error("[@sg-widgets/shared-core] " + message);
    }
}
export function deprecationWarning(config, message) {
    var logFunction = config !== undefined ? config.debug : console.debug;
    if (process.env.NODE_ENV !== "production") {
        logFunction = config !== undefined ? config.warn : console.warn;
    }
    logFunction("[@sg-widgets/shared-core] DEPRECATION WARNING: " + message);
}
